<template>
    <commonPopup
        header="拼团规则"
        footer="我知道了"
        @footerClick="footerClick">
        <div class="ctn">
            <p v-for="(item , index) in groupRule" :key="index">{{item}}</p>
        </div>        
    </commonPopup>
</template>

<script>
import commonPopup from "@/components/common/popup.vue";
export default {
  name: "rule",
  props:{
      groupRule: Array,
  },
  components: {
    commonPopup
  },
  created: function() {},
    methods:{
      footerClick(){
          this.$emit('footerClick');
      },
  }
};
</script>

<style lang="scss" scoped>
    .ctn {
        font-family: PingFangSC-Regular;
        font-size: .28rem;
        line-height: .40rem;
        color: #919294;
        padding: .3rem .53rem;
        p {
            margin-bottom: .1rem;
        }
    }
</style>